var map = {
	"./FooterExtensions": 50967,
	"./FooterExtensions.ts": 50967,
	"./README.md": 54198,
	"./SignInOverlayExtensions": 69082,
	"./SignInOverlayExtensions.ts": 69082
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87554;